import classNames from "classnames";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { TextButton } from "../../../../../textButton/textButton";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { useStore } from "../../../../../../models";
import settingsStyles from "../../../../../../styles/settings.css";
import { TagPicker } from "../../../../../forms/tagPicker/tagPicker";
import { TagsList } from "../../../tagName/tagsList";
import { GroupTagIds } from "../../types";

interface Props {
  tagIds: GroupTagIds;
  onDelete?(tagId: string): void;
  initialIsOpen?: boolean;
}

export const TagsInput = observer(({ tagIds, onDelete, initialIsOpen }: Props) => {
  const { tagsStore } = useStore();
  const [isPicking, setIsPicking] = useState(initialIsOpen);
  const tags = tagsStore.getFromIds(tagIds.$);
  const pickableTags = tagsStore.getWithoutIds(tagIds.$);

  const renderInput = () =>
    isPicking ? (
      <TagPicker
        onOutsideClick={() => setIsPicking(!tagIds.$.length)}
        className={classNames(
          !!tagIds.$.length && settingsStyles["list-margin"],
          settingsStyles["input-width-bigger"]
        )}
        onChange={(tag) => {
          tagIds.reset([...tagIds.$, tag.id]);
          setIsPicking(false);
        }}
        values={pickableTags}
        hasError={tagIds.hasError}
        initialIsOpen={!!tagIds.$.length}
        onStateChange={
          initialIsOpen
            ? undefined
            : (_, state) => (!state.isOpen ? setIsPicking(false) : undefined)
        }
      />
    ) : (
      <TextButton
        text={"+ " + intl.formatMessage("settings.tagGroups.form.tags.button")}
        className={settingsStyles["list-margin"]}
        onClick={() => setIsPicking(true)}
      />
    );

  return (
    <div>
      {!!tagIds.$.length && <TagsList tags={tags} onTagDelete={onDelete} />}
      {!!pickableTags.length && renderInput()}
    </div>
  );
});
